
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import authProvider from '@/utility/authProvider';
import orderServices from '@/services/order-service';

import { BillOfLadingModel } from '@/models/bill-of-lading';
import formatNumber from '@/shared/filters/format-number';
import { DATA } from '../../../../../config/data';

@Component
export default class BillOfLading extends Vue {

    @Prop({default: null})
    private orderId!: number;

    private listBillOfLading: BillOfLadingModel[] = [];

    @Watch('orderId', { immediate: true, deep: true })
    private async watchOrderId() {
        if (this.orderId) {
            await this.loadData();
        }
    }

    private async loadData() {
        const result = await orderServices.getBillOfLading(this.orderId, 0, authProvider.getToken());
        this.listBillOfLading = [];
        if (result && result.status === 200 && result.data.data) {
            const orderCodes = result.data.data.order_codes;
            const orderTransactions = result.data.data.order_transactions;

            for (const item of orderTransactions) {
                const bill = new BillOfLadingModel();
                bill.createdBy = item.CreatedBy;
                bill.createdDate = item.CreatedDate;
                bill.id = item.ID;
                bill.modifiedBy = item.ModifiedBy;
                bill.modifiedDate = item.ModifiedDate;
                bill.orderCodeId = item.OrderCodeID;
                bill.orderId = item.OrderID;
                bill.transactionCode = item.TransactionCode;
                bill.packageType = item.PackageType;
                bill.status = item.Status;
                bill.statusDetail = DATA.billOfLadingStatus.find(x => x.value === item.Status) || {}
                bill.uId = item.UID;
                bill.userName = item.Username;
                bill.weight = item.Weight > 0 ? `${formatNumber(item.Weight, '0,0.[0000]')} kg` : '';
                bill.weightByVolume = item.WeightByVolume > 0 ? `${formatNumber(item.WeightByVolume, '0,0.[0000]')} kg` : '';
                bill.volume = item.Width > 0 ? `${item.Length}cm x ${item.Width}cm x ${item.Height}cm` : '';
                bill.feeWeight = item.FeeWeight;
                bill.feeWeightAmount = item.FeeWeightAmount;
                this.listBillOfLading.push(bill);
            }
        }
    }
}
